import styled from 'styled-components';
import { Link } from 'react-router-dom';

const OtherSection = styled.div`
  display: block;
  position: relative;
  padding: 15px 54px 15px 24px;
  border-radius: ${({ theme }) => theme.borderRadius};
  background-color: ${({ theme }) => theme.colors.uiLL};
  color: ${({ theme }) => theme.colors.font};
  transition: all 0.25s ease;

  svg {
    position: absolute;
    top: 50%;
    right: 12px;
    margin-top: -9px;
    transition: transform 0.25s ease;
  }

  &:hover {
    color: ${({ theme }) => theme.mainColor};

    svg {
      transform: translateX(3px);
    }
  }

  &:first-of-type {
    margin-bottom: 18px;
  }

  strong,
  small {
    display: block;
  }

  strong {
    padding-bottom: 3px;
  }
`;

export const OtherSectionLink = OtherSection.withComponent(Link);
